import React, { useContext } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Password from './Password/Password';
import Unauthorized from './Unauthorized';
import { PublicPasswordContext } from '../context/PublicPasswordContext';


const Routing = () => {
    const context = useContext(PublicPasswordContext);
    const ProtectedRoute = ({ component: Component, ...rest }) => (
        <Route
            render={props =>
                context.isAuthenticated ? <Component {...props} /> : <Unauthorized />
            }
            {...rest}
        />
    )

    if (!context.isAuthenticated) {
        return <Unauthorized />
    }

    return (
        <Router>
            <div>
                <Route exact path="/" component={Unauthorized} />
                <ProtectedRoute exact path="/aktivera" component={Password} />
                <ProtectedRoute exact path="/aterstall" component={Password} />
            </div>
        </Router>
    )
}

export default Routing;
